import React from 'react';

const ASEANAIGovernance = () => (
  <article className="news-article-body">
    <p className="news-lead">
      Southeast Asia is home to over 680 million people, 11 distinct regulatory environments,
      and some of the fastest-growing digital economies in the world. Getting AI governance
      right here matters enormously - not just for each country individually, but for the
      companies and citizens navigating between them. In 2024-2025, the region saw a surge
      of AI governance activity at both the national level and through ASEAN's collective
      frameworks.
    </p>

    <h2>Singapore - the regional standard-setter</h2>
    <p>
      Singapore continues to lead on practical AI governance. The 2024 update to its Model
      AI Governance Framework, combined with the dedicated Agentic AI Framework and the
      Project Moonshot testing toolkit, gives Singapore arguably the most comprehensive
      practical governance infrastructure in the region.
    </p>
    <p>
      Singapore is also the host country for ASEAN's secretariat, giving it natural
      influence over regional standards. The ASEAN AI Governance Framework, developed with
      Singapore's active participation, draws heavily on Singapore's domestic approach.
    </p>

    <h2>Malaysia - national AI office and governance framework</h2>
    <p>
      Malaysia established the National AI Office (NAIO) in 2024 under the Ministry of
      Digital. Its mandate covers the AI Governance and Ethics (AIGE) framework for public
      sector AI, AI readiness assessments for government agencies, and oversight of the
      National AI Roadmap.
    </p>
    <p>
      Malaysia has taken a practical, enablement-focused approach - similar to Singapore -
      rather than moving directly to binding legislation. The AIGE framework focuses on
      transparency, human oversight, and fairness, with sector-specific guidance for
      healthcare, finance, and education.
    </p>

    <h2>Indonesia - data protection as the foundation</h2>
    <p>
      Indonesia's Personal Data Protection Law (UU PDP) came into force in 2024 after years
      of legislative development. While not an AI-specific law, it creates the data
      governance foundation that AI regulation depends on - defining rights over personal data,
      obligations for data processors, and enforcement mechanisms.
    </p>
    <p>
      Presidential Regulation 68/2024 added AI-specific provisions, covering AI system
      transparency, accountability for automated decisions, and government AI deployment
      standards. With 270 million people and a rapidly growing tech sector, Indonesia's
      regulatory approach matters significantly for the region.
    </p>

    <h2>Philippines - the NAIS-PH strategy</h2>
    <p>
      The Philippines released the National AI Strategy (NAIS-PH) in 2024, covering
      five priority areas: AI for government services, AI in education, AI for the economy,
      AI infrastructure, and AI governance. It sets targets through 2028 and includes
      a framework for responsible AI use in government procurement.
    </p>

    <h2>Thailand - draft AI law in development</h2>
    <p>
      Thailand's Draft AI Act, circulated for consultation in 2025, follows the EU AI Act's
      risk-based classification approach closely. High-risk applications require conformity
      assessments before deployment. The Thai Digital Economy and Society Ministry has
      indicated it expects the law to be enacted by 2026.
    </p>

    <h2>The ASEAN Digital Economy Framework Agreement (DEFA)</h2>
    <p>
      The regional picture is being shaped by the ASEAN DEFA, which includes AI governance
      harmonisation as one of its pillars. The goal is mutual recognition of AI conformity
      assessments across member states - so a product approved in Singapore doesn't need
      a full re-assessment in Malaysia or Thailand. That harmonisation is still in progress,
      but the direction is clear.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        Southeast Asia's AI governance landscape is fragmented but moving fast. The challenge
        for regional businesses is navigating different compliance requirements across markets.
        The opportunity is that countries willing to lead on clear, practical governance -
        like Singapore and Vietnam - can attract AI investment from companies that want
        regulatory certainty. ASEAN harmonisation, if it happens, would be a major unlock
        for the entire regional digital economy.
      </p>
    </div>
  </article>
);

export default ASEANAIGovernance;
